import { withStyles } from '@material-ui/core';
import Label from '../../Dispatch/RouteExecution/ProDetails/common/Label';
import Value from '../../Dispatch/RouteExecution/ProDetails/common/Value';
import { formatAddress } from '../../Dispatch/utils/utils';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  shipperValue: {
    fontSize: theme.headerTextFontSize,
    marginBottom: 4
  },
  shipperDetailContainer: {
    margin: '16px 0px'
  },
  detailsContainer: {
    display: 'flex',
    marginBottom: 16
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  }
});
const ShipperDetails = ({ classes, proData }) => {
  return (
    <div className={classes.container}>
      <Label labelText="SHIPPER DETAILS" />
      <div className={classes.headerContainer}>
        <Value value={proData.shipperName} customClasses={classes.shipperValue} />
        <Value
          value={proData.shipperCode && `#${proData.shipperCode}`}
          customClasses={classes.shipperValue}
        />
      </div>
      <Label
        labelText={formatAddress({
          address: proData.shipperAddress,
          address2: proData.shipperAddress2,
          city: proData.shipperCity,
          state: proData.shipperState,
          zip: proData.shipperZip
        })}
        upperCase={false}
      />
    </div>
  );
};

export default withStyles(styles)(ShipperDetails);
